import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FlowStepComponent } from './flow-step.component';

@NgModule({
  imports: [CommonModule],
  exports: [FlowStepComponent],
  declarations: [FlowStepComponent],
  providers: [],
})
export class FlowStepModule {

}
